import { Injectable } from '@angular/core';

// pdfmake ships as UMD bundles. With modern Angular builders (ESM), `import * as ...`
// returns an immutable namespace object, so we must resolve the underlying default export
// (or the module itself) and mutate that.
import * as pdfMakeModule from 'pdfmake/build/pdfmake';
import * as pdfFontsModule from 'pdfmake/build/vfs_fonts';

const pdfMake: any = (pdfMakeModule as any).default ?? pdfMakeModule;
const pdfFonts: any = (pdfFontsModule as any).default ?? pdfFontsModule;

// Wire fonts once.
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

@Injectable({ providedIn: 'root' })
export class PdfService {
    download(docDefinition: any, filename: string): void {
        pdfMake.createPdf(docDefinition).download(filename);
    }

    open(docDefinition: any): void {
        pdfMake.createPdf(docDefinition).open();
    }

    print(docDefinition: any): void {
        pdfMake.createPdf(docDefinition).print();
    }
}
